export const LogoutReminderPopupType = {
    closed: 'closed',
    warning: 'warning',
    timeout: 'timeout',
    passiveLogout: 'passiveLogout'
};
